module.exports = __webpack_public_path__ + "static/media/cropping.03255ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/photography/cropping.png
// module id = 731
// module chunks = 0